
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TerminalModal } from '../model/terminal.model';
import { TerminalService } from '../terminal.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-terminal-edit',
  standalone: false,
  templateUrl: './terminal-edit.component.html',
  styleUrl: './terminal-edit.component.scss'
})
export class TerminalEditComponent {

  title: string = "New Terminal";
  editForm: FormGroup;
  TerminalInfo: TerminalModal = {};
  isFormDirty: boolean = false;
  ratingList: TerminalModal[] = [];
  TerminalData: TerminalModal[] = [];
  masterTerminals: TerminalModal[] = [];
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private terminalService: TerminalService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    let TerminalId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: this.builder.control(this.TerminalInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.TerminalInfo.name, [Validators.required, Validators.maxLength(50)]),
      short_code: this.builder.control(this.TerminalInfo.short_code,),
      description: this.builder.control(this.TerminalInfo.description),
      type: this.builder.control(this.TerminalInfo.type),
      is_oo_terminal: this.builder.control(this.TerminalInfo.is_oo_terminal),
      is_active: this.builder.control(this.TerminalInfo.is_active),

      operation_mode: this.builder.control(this.TerminalInfo.operation_mode ?? 1),
      is_order_shared: this.builder.control(this.TerminalInfo.is_order_shared ?? 1),
      disabled_pos_functions: this.builder.control<string[]>(
        this.TerminalInfo.disabled_pos_functions ?? [], // Initialize with empty array

      ),
      parent_id: this.builder.control(this.TerminalInfo.parent_id),
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (TerminalId !== null && parseInt(TerminalId) !== 0) {
      this.setTerminalInfo(TerminalId);
    }
    this.permission = this.permissionService.getPagePermission('station');

  }



  onCheckboxChange(event: MatCheckboxChange): void {
    const currentValues = this.editForm.get('disabled_pos_functions')?.value as string[];
    const value = event.source.value;

    if (event.checked) {
      currentValues.push(value);
    } else {
      const index = currentValues.indexOf(value);
      if (index >= 0) {
        currentValues.splice(index, 1);
      }
    }

    this.editForm.get('disabled_pos_functions')?.setValue([...currentValues]);
  }

  setupOperationModeListener(): void {
    this.editForm.get('operation_mode')?.valueChanges.subscribe((mode) => {
      const disabledFunctionsControl = this.editForm.get('disabled_pos_functions');

      if (mode === 1) { // Master mode
        // Clear all checkboxes
        disabledFunctionsControl?.setValue([]);
      }
      else if (mode === 2) { // Slave mode
        // Set hardcoded defaults
        const slaveDefaults = [
          'day_process',
          'bill_discount',
          'daily_expense',
          'open_till',
          'sync_now',
          'open_cash_drawer'
        ];
        disabledFunctionsControl?.setValue(slaveDefaults);
      }
    });

  }
  ngOnInit(): void {
    //  this.loadRating();    
    this.setupOperationModeListener();
    this.loadData();
  }

  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/system/station']);

  }

  /**
   * If tas is is null set an empty area info
   * if area id is not null call api to rtrive the info
   * @param TerminalId 
   */
  setTerminalInfo(TerminalId: any): void {

    let response = this.terminalService.getTerminalById(TerminalId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.TerminalInfo = response.data.terminals;
          this.TerminalInfo.type = Number(this.TerminalInfo.type);
          this.TerminalInfo.operation_mode = Number(this.TerminalInfo.operation_mode);
          this.TerminalInfo.is_order_shared = Number(this.TerminalInfo.is_order_shared);
          this.TerminalInfo.is_oo_terminal = Number(this.TerminalInfo.is_oo_terminal);
          this.TerminalInfo.is_active = Number(this.TerminalInfo.is_active);
          this.TerminalInfo.parent_id = Number(this.TerminalInfo.parent_id);

          console.log(this.TerminalInfo.type)
          this.editForm.patchValue({
            ...this.TerminalInfo,
            disabled_pos_functions: this.TerminalInfo.disabled_pos_functions || []
          });
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }




  loadData(): void {
    const requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 10,
            offset: 0
          }
        },
        sort: [
          {
            column: 'name',
            order: 'asc'
          }
        ]
      }
    };

    let response = this.terminalService.getTerminalList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.TerminalData = response.data.terminals



      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }

    });

  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.TerminalInfo.id == 0) ? "New Region" : "Editing : " + this.TerminalInfo.name;
    return title;
  }

  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {

    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      Object.assign(this.TerminalInfo, this.editForm.value);
      this.terminalService.update(this.TerminalInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.TerminalInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/system/station']);
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
            this.router.navigate(['/system/station']);

          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });

    } else {
      this.editForm.markAllAsTouched();
    }
  }

}
